import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Button } from '@/components/shadcn/button'
import { Dialog, DialogContent, DialogTrigger } from '@/components/shadcn/dialog'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconDocumentTextOutline } from '@icons/IconDocumentTextOutline'
import { Suspense, useState } from 'react'
// import { logsMockData } from './logsMockData'
import { DataTable } from '@/components/ui/DataTable/DataTable'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { logsTableColumns } from './logsTableColumns'

export function LogsDialog({
  title,
  description,
  children,
}: {
  title: string
  description: string
  children: React.ReactNode
}) {
  const [open, setOpen] = useState(false)
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="icon" variant="ghost" className="size-7 shrink-0 px-0 py-0">
          <IconDocumentTextOutline />
        </Button>
      </DialogTrigger>
      <DialogContent className="z-[1001] max-h-[calc(100vh-60px)] max-w-[calc(100vw-60px)] bg-background">
        {/* {(title || description) && (
          <DialogHeader style={{ height: COMPONENT_HEADER_HEIGHT }}>
            <div className="flex items-end justify-between gap-2 pt-3">
              <div>
                {title && <DialogTitle className="text-lg font-normal">{title}</DialogTitle>}
                {description && <DialogDescription>{description}</DialogDescription>}
              </div>
            </div>
          </DialogHeader>
        )} */}
        {open && (
          <div style={{ height: `calc(100vh - 88px)` }}>
            <QueryErrorBoundary errorMessage="Failed to load logs">
              <Suspense fallback={<LoadingComponent text="Fetching logs..." />}>
                {/* <div style={{ maxHeight: `calc(100vh - 88px - ${COMPONENT_HEADER_HEIGHT}px)` }}>{children}</div> */}
                {children}
                {/* <LoadingComponent text="Fetching logs..." /> */}
              </Suspense>
            </QueryErrorBoundary>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

// type MessagesDagsterMessageEvent = RestSchemas['Messages.Dagster.MessageEvent']

export function LogsContent({ runId, applicationId }: { runId: string; applicationId?: number }) {
  const { getDagsterApiGetDagsterRunLogs } = useRestClient()
  const { data: dagsterRunLogs } = getDagsterApiGetDagsterRunLogs.useSuspenseQuery(
    {
      query: { applicationId },
      path: { runId },
    },
    {
      select: (data) => data?.payload?.data?.pipelineRunLogs?.messages ?? [],
    }
  )
  return (
    <DataTable
      columns={logsTableColumns}
      // data={logsMockData.payload.data.pipelineRunLogs.messages as unknown as MessagesDagsterMessageEvent[]}
      data={dagsterRunLogs}
    />
  )
}
